import { Button, Dialog, Icon, Pagination, Select, Table, Tree } from "@alifd/next";
import { BefGlobalContext, BefMessageButtonType, BefMessageServiceContext, BefMessageType, BefPageServiceContext } from "@beflam/bef-core";
import { useContext, useEffect, useRef, useState } from "react";
import { MixIcon } from "../MixIcon";
import axios from "axios";
import { createComponentPage } from "../../lib/renderSchemaHelper";
import { NodeElement } from "@alifd/next/types/tree/types";
import AddForder from "./addForder";
import AddDataSet from "../DataSets/addDataSet";
import DataSetManager from "../DataSets/dataManager";
import DocumentManager from "./documentManager";
import { padEnd } from "lodash";
const Option = Select.Option;
export function FileManager() {
    const messageService = useContext(BefMessageServiceContext);
    const sGlobal = useContext(BefGlobalContext);
    const pageService = useContext(BefPageServiceContext);
    let [dataSource, setDataSource] = useState({ data: [] as any[], dataSource: [] as any[], currentPage: 1, selectedRowKeys: [], selectRecords: [] as any[], columnWidth: {} as any });
    let [visible, setVisible] = useState({ add: false, edit: false, updatePassword: false, display: false, excelImport: false, userPermission: false, addDataSet: false });
    const [divHeight, setDivHeight] = useState<any>(0);
    const perRef = useRef(null);
    const pageSize = 15;
    let fileType = useRef<any>("Public");
    const [menuData, setMenuData] = useState<any>([]);
    const [selectedKeys, setSelectedKeys] = useState<any>([]);
    const [isShowRight, setIsShowRight] = useState<any>({ dataset: false, document: false });
    let currentRight = useRef<any>();
    const [depData, setDepData] = useState<any>([]);
    const [depMenu, setDepMenu] = useState<any>({});
    let currentTypeId = useRef<any>("");
    const [treeWidth, setTreeWidth] = useState<number>(200);
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const splitRef = useRef<HTMLDivElement>(null);
    const isDraggingRef = useRef(false);
    const setDataSourceEx = (data: any) => {
        dataSource = data;
        setDataSource(data);
    }
    const setVisibleEx = (data: any) => {
        visible = data;
        setVisible(data);
    }

    const onSplitMouseDown = (e: React.MouseEvent) => {
        e.preventDefault();
        isDraggingRef.current = true;
        setIsDragging(true);
        document.addEventListener('mousemove', onSplitMouseMove);
        document.addEventListener('mouseup', onSplitMouseUp);
    }
    const onSplitMouseMove = (e: MouseEvent) => {
        if (!isDraggingRef.current || !splitRef.current) return;
        const containerRect = splitRef.current.parentElement!.getBoundingClientRect();
        let newWidth = e.clientX - containerRect.left;
        if (newWidth < 150) newWidth = 150;
        if (newWidth > containerRect.width - 200) newWidth = containerRect.width - 200;
        setTreeWidth(newWidth);
    }
    const onSplitMouseUp = () => {
        isDraggingRef.current = false;
        setIsDragging(false);
        document.removeEventListener('mousemove', onSplitMouseMove);
        document.removeEventListener('mouseup', onSplitMouseUp);
    }
    useEffect(() => {
        return () => {
            document.removeEventListener('mousemove', onSplitMouseMove);
            document.removeEventListener('mouseup', onSplitMouseUp);
        }
    }, []);

    const refresh = async () => {
        try {
            setIsShowRight(false);
            setSelectedKeys([]);
            let _fileType = "Public";
            if (fileType && fileType.current)
                _fileType = fileType.current;
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            const response = await axios.get(
                sGlobal.config.host + `/api/document/list?type=${_fileType}`,
                { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            );

            // console.log(response.data);
            if (_fileType !== 'Department') {
                if (response.data.success.toString() !== 'true') {
                    throw response.data.error;
                }
                else {
                    let menudata = formatMenuData(response.data.data);
                    setMenuData(menudata)
                    // dataSource.data = data;
                    // onPaginationChange(dataSource.currentPage);

                }
            } else {
                let _deps = [];
                let _depMenu = {} as any;
                for (var key in response.data) {
                    _deps.push(key);
                    let menudata = formatMenuData(response.data[key]);
                    _depMenu[key] = menudata;

                }
                if (_deps.length > 0) {
                    currentTypeId.current = _deps[0];
                    setDepData(_deps);
                    setDepMenu(_depMenu);
                    setMenuData(_depMenu[_deps[0]]);
                }
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "知识库列表获取"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }

    const formatMenuData = (menudata: any) => {
        let dataset = {
            label: '知识库文档',
            key: '@@1',
            children: []
        }
        let fileset = {
            label: '数据文档',
            key: '@@2',
            children: []
        }
        if (menudata) {
            let _datas = [];
            if (menudata.Datasets.length > 0) {
                _datas = menudata.Datasets.map((item: any) => {
                    return {
                        label: item.Name,
                        key: item.Id,
                        isLeaf: true,
                        type: 'dataset',
                        realdata: item
                    }

                });

            }
            dataset.children = _datas;
            let _docs = [];
            if (menudata.Documents.length > 0) {
                _docs = menudata.Documents.map((item: any) => {
                    return {
                        label: item.Name,
                        key: item.Name,
                        isLeaf: true,
                        type: 'document',
                        realdata: item
                    }

                });

            }
            fileset.children = _docs;
        }
        return [dataset, fileset];
    }
    const deleteData = async () => {
        try {
            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0) throw new Error("请选择至少一条数据");
            const ids = dataSource.selectRecords.map((val) => val.Id).join(",");
            const data = dataSource.selectRecords.map((val) => val.Id);
            let messageResult = await messageService.showMessage({ mes: `是否确定删除Id：<${ids}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (messageResult === 1) {
                sGlobal.showloading = true;
                sGlobal.showLoadingEvent.emit();
                const response = await axios.delete(
                    sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets`,
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}`, data: data } }
                ).then(response => {
                    if (response.data.code.toString() === '0') {
                        messageService.showMessage({ mes: `删除<${ids}>成功` });
                        refresh();
                    }
                    else
                        throw JSON.stringify(response.data);
                }).catch(error => {
                    throw error;
                });
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除知识库"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }


    let dataRef = useRef<any>(null);
    const onAdd = async () => {
        try {

            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            if (!dataRef || !dataRef.current) throw new Error("dataRef is null");
            let validateResult = await dataRef.current.validate();
            if (validateResult.errors != null) return;
            let data = {} as any;
            let _depId = "";
            if (fileType.current === "Department")
                _depId = currentTypeId.current;
            data = { type: fileType.current, typeId: _depId, path: dataRef.current.dataSource.Name };
            const response = await axios.post(
                sGlobal.config.host + `/api/document/addforder`,
                data,
                { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            ).then(response => {
                if (response.data.success.toString() === 'true') {
                    messageService.showMessage({ mes: `新增文件夹<${data.path}>成功` });
                    setVisibleEx({ ...visible, add: false });
                    refresh();
                }
                else {
                    throw JSON.stringify(response.data.error);
                }
            }).catch(error => {
                throw error;
            });

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "数据文档文件夹新增"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const onAddDataSet = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            if (!dataRef || !dataRef.current) throw new Error("dataRef is null");
            let validateResult = await dataRef.current.validate();
            if (validateResult.errors != null) return;
            let data = dataRef.current.dataSource;
            let _depId = "";
            if (fileType.current === "Department")
                _depId = currentTypeId.current;
            const response = await axios.post(
                sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets?type=${fileType.current}&typeid=${_depId}`,
                data,
                { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            ).then(response => {
                if (response.data.code.toString() === '0') {

                    messageService.showMessage({ mes: `新增<${data.Name}>成功` });
                    setVisibleEx({ ...visible, addDataSet: false });
                    refresh();
                }
                else {
                    throw JSON.stringify(response.data);
                }
            }).catch(error => {
                throw error;
            });

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "知识库新增"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const onTypeChange = (value: any) => {
        fileType.current = value;
        currentTypeId.current = ""
        setSelectedKeys([]);
        setIsShowRight(false)
        refresh();
    }
    const onDepChange = (value: any) => {
        currentTypeId.current = value;
        setSelectedKeys([]);
        setIsShowRight(false)
        setMenuData(depMenu[value])
    }
    useEffect(() => {
        refresh();
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                //   console.log('Element size changed:', width, height);
                let _height = height;
                if (height > 0) {
                    let diff = _height - 110.45;
                    if (diff > 0) {
                        if (divHeight !== diff.toString() + 'px')
                            setDivHeight(diff.toString() + 'px');
                    }
                    else
                        setDivHeight('232px');
                }

            }
        });

        if (perRef.current) {
            resizeObserver.observe(perRef.current);
        }

        return () => {
            if (perRef.current) {
                resizeObserver.unobserve(perRef.current);
            }
        };
    }, []);

    const onTreeSelect = async (keys: any, extra: any) => {
        try {
            if (keys.length > 0) {
                if (keys[0] === "@@1" || keys[0] === "@@2") {

                } else {
                    setSelectedKeys([keys[0]]);
                    if (extra.node.props.type === "document") {
                        currentRight.current = extra.node.props.realdata;
                        setIsShowRight({ dataset: false, document: true });
                    } else {

                        currentRight.current = extra.node.props.realdata;
                        setIsShowRight({ dataset: true, document: false });
                    }
                }

            }
        }
        catch (ex) {
            messageService.showMessage(messageService.handleErr(ex, "部门切换"));
        }
    }
    const treeNodeAdd = (key: string) => {
        if (key === "@@1")
            setVisible({ ...visible, addDataSet: true });
        if (key === "@@2")
            setVisible({ ...visible, add: true })
    }
    const treeNodeRender = (node: any) => {
        let isParent = node.key === "@@1" || node.key === "@@2" ? true : false;

        return <div className="tree-node-div">
            <label className="tree-label">{node['label']}</label>
            {isParent && <button className="tree-btn" onClick={() => { treeNodeAdd(node.key) }} title="新增"> <Icon type="add" /></button>}
        </div>
    }
    return (
        <>
            <div className="bef-user bef-user-section padding-24 gap-24-i" style={{ position: 'relative' }}>
                <div className="bef-user-header " style={{ display: 'flex', flexDirection: 'row', gap: 24, height: 'auto', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <label style={{ fontSize: '14px', color: '#333', margin: 'auto' }}>文档类型</label>
                            <div className="custom-form-control">
                                <Select
                                    id="basic-demo"
                                    onChange={onTypeChange}

                                    defaultValue="Public"
                                >
                                    <Option value="Public">公开文档</Option>
                                    <Option value="Department">部门文档</Option>
                                    <Option value="Private">私有文档</Option>
                                    {/* <Option value="Shared">分享文档</Option> */}
                                </Select>
                            </div>

                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            {fileType.current === 'Department' &&
                                <>
                                    <label style={{ fontSize: '14px', color: '#333', margin: 'auto' }}>部门</label>
                                    <div className="custom-form-control"> <Select
                                        id="basic-demo"
                                        onChange={onDepChange}
                                        value={currentTypeId.current}
                                        style={{ height: '100%' }}
                                    >{
                                            depData.map((item: any) => {

                                                return <Option value={item}>{item}</Option>
                                            })
                                        }

                                    </Select></div>

                                </>}
                        </div>
                    </div>

                    <div className="bef-user-btngroup justify-end">
                        <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#3B5998', borderColor: '#3B5998' }} type="normal" size="medium" onClick={refresh}><MixIcon value="1:reload" size="xs" />刷新</Button>
                    </div>
                </div>
                <div className='custom-card  flex-1 display-flex-col' style={{ overflow: 'hidden' ,background:'#ffffff00',padding:0 ,height:'100%'}}>
                    <div style={{ display: 'flex', flex: 1,height:'100%'}}>
                        <div style={{ width: `${treeWidth}px`,flex:'0 0 auto',background:'#ffffff',padding:'16px',borderRadius:'5px' ,overflow:'auto'}}>
                            <Tree defaultExpandAll dataSource={menuData}
                                labelRender={treeNodeRender}
                                onSelect={onTreeSelect}
                                selectedKeys={selectedKeys}
                                className="bef-file-tree"
                                isNodeBlock
                                style={{ width: '100%' }}

                            />
                        </div>
                        <div
                            ref={splitRef}
                            onMouseDown={onSplitMouseDown}
                            style={{
                                width: '6px',
                                flex: '0 0 auto',
                                cursor: 'col-resize',
                                margin: '0 4px',
                                borderRadius: '2px',
                                background: isDragging ? '#3B5998' : 'transparent',
                                transition: isDragging ? 'none' : 'background 0.2s',
                            }}
                            onMouseEnter={(e) => { if (!isDraggingRef.current) e.currentTarget.style.background = '#d8d8d8'; }}
                            onMouseLeave={(e) => { if (!isDraggingRef.current) e.currentTarget.style.background = 'transparent'; }}
                        />
                        <div className="flex-1 display-flex-col  " ref={perRef} style={{ overflow: 'hidden',background:'#ffffff00',marginLeft:'0'  }}>
                            {isShowRight.dataset && <DataSetManager datas={currentRight.current} type={fileType.current} typeId={currentTypeId.current} changeEvent={(val: any) => {
                                if (val.toString() == 'true') {
                                    setIsShowRight(false);
                                    refresh();
                                }
                            }}  />}
                            {isShowRight.document && <DocumentManager datas={currentRight.current} type={fileType.current} typeId={currentTypeId.current}  style={{padding:'16px',background:'#ffffff',borderRadius:'5px' }}/>}

                        </div>
                    </div>

                </div>
            </div>
            <Dialog v2 title="新增文件夹" width={800} visible={visible.add} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, add: false })} onOk={onAdd}>
                <AddForder ref={dataRef} />
            </Dialog>
            <Dialog v2 title="新增知识库" width={800} visible={visible.addDataSet} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, addDataSet: false })} onOk={onAddDataSet}>
                <AddDataSet ref={dataRef} />
            </Dialog>
        </>
    );
}